import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customBaseURL, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { BLOCK_DATE_LIST, BLOCK_DATE_LIST_SUCCESS, BLOCK_DATE_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* blockedDatesList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/block-dates`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: BLOCK_DATE_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: BLOCK_DATE_LIST_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: BLOCK_DATE_LIST_ERROR, payload: error });
  }
}

export function* watchListBlockedDates() {
  yield takeEvery(BLOCK_DATE_LIST, blockedDatesList);
}

function* listBlockedDatesSaga() {
  yield all([fork(watchListBlockedDates)]);
}

export default listBlockedDatesSaga;
